import { Outlet } from "react-router-dom";
import { QueryProvider } from "./QueryProvider";
import { Frame } from "@shopify/polaris";
import { getShopName } from "../lib/getShopName";
import { useEffect, useRef, useState } from "react";
import { buildUrl } from "../lib/buildUrl";
import { getHost } from "../lib/getHost";
import { isInsideIFrame } from "../lib/isInsideIframe";
import { identifyUser } from "../lib/mixpanel";
import { customFetch } from "../lib/customFetch";

export function AppLayout() {
  const shopName = getShopName();
  const host = getHost();
  const ref = useRef<HTMLAnchorElement>(null);

  const [status, setStatus] = useState({ loading: true, error: "" });

  const authUrl =
    `${process.env.REACT_APP_OAUTH_URL}?shop=${shopName}&host=${host}` as string;

  useEffect(() => {
    if (!shopName) return;

    fetch(buildUrl(`/stores/${shopName}/check-oauth`), {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then(async (resp) => {
        console.log({ resp });
        if (resp.statusCode === 200 && resp.data.shopName) {
          identifyUser(resp.data.id, {
            shopName: resp.data.shopName,
            name: resp.data.name,
            email: resp.data.email,
          });

          try {
            const migrateResp = await customFetch(
              buildUrl("/migrate-token"),
              { method: "POST" }
            );

            if (migrateResp.statusCode === 400) {
              console.error("Token migration failed:", migrateResp.error);
            }
          } catch (e) {
            console.error("Token migration failed:", e);
          }

          setStatus({ loading: false, error: "" });
        } else if (resp.statusCode === 400) {
          // Not installed yet — with Shopify managed install, our backend has no
          // token until the embedded session token is exchanged. Bootstrap it.
          try {
            const bootstrapResp = await customFetch(
              buildUrl(`/stores/${shopName}/bootstrap`),
              { method: "POST" }
            );

            if (bootstrapResp.statusCode === 200) {
              window.location.reload();
              return;
            }

            console.error("Bootstrap failed:", bootstrapResp.error);
          } catch (e) {
            console.error("Bootstrap failed:", e);
          }

          if (isInsideIFrame) {
            // escape the admin iframe and start OAuth
            window.top!.location.href = authUrl;
          } else {
            // redirect to auth
            window.location.href = authUrl;
          }
        } else if (resp.error) {
          setStatus({ loading: false, error: resp.error });
          // show error
        }
      });
  }, []);

  if (status.loading) {
    return (
      <>
        <p>Loading...</p>
      </>
    );
  }

  if (status.error) {
    return <p>{status.error}</p>;
  }

  return (
    <QueryProvider>
      <Frame>
        <Outlet />
      </Frame>
    </QueryProvider>
  );
}
